'use client';

import { useEffect } from 'react';
import { usePageViewTracking, useReadingProgress } from '@/lib/hooks/useActivityTracking';

interface ContentPageClientProps {
  contentType: string;
  contentSlug: string;
  contentTitle: string;
  tags?: string[];
}

/**
 * Client-side wrapper for ContentPage to handle activity tracking
 * This component is invisible and only manages tracking logic
 */
export default function ContentPageClient({
  contentType,
  contentSlug,
  contentTitle,
  tags = []
}: ContentPageClientProps) {
  // Track page view
  usePageViewTracking(contentType, contentSlug, contentTitle);

  // Track reading progress
  useReadingProgress(contentType, contentSlug);

  // Store reading history for recommendations
  useEffect(() => {
    const history = JSON.parse(localStorage.getItem('reading_history') || '[]');

    // Add current article to history
    const newItem = {
      slug: contentSlug,
      category: contentType,
      tags,
      timestamp: Date.now()
    };

    // Remove duplicates and add to front
    const filtered = history.filter((item: any) => item.slug !== contentSlug);
    const updated = [newItem, ...filtered].slice(0, 50); // Keep last 50 items

    localStorage.setItem('reading_history', JSON.stringify(updated));
  }, [contentType, contentSlug, tags]);

  // This component renders nothing - it's just for tracking
  return null;
}
